module.exports = {
  buildVersion: "0.6.3",
  buildDate: 1686662507009,
}